import React from 'react';
import TextField from '../../components/Fields/TextField';
import { Button, Grid } from '@mui/material';
import FieldArray, { formatName } from '../../components/Fields/FieldArray';
import PhoneField from '../../components/Fields/PhoneField';
import DateField from '../../components/Fields/DateField';

type Props = {
  onSubmit: () => void
}

function PlaygroundForm({ onSubmit }: Props) {
  return (
    <form onSubmit={onSubmit}>
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12}>
          <TextField name="myCustomField"/>
        </Grid>

        <Grid item={true} xs={12}>
          <Grid container={true} spacing={3}>

            <FieldArray name="myCustomFieldArray">
              {(name, { fields }) => (
                fields.map((value, index) => (
                  <Grid key={value.id} item={true} xs={12}>
                    <TextField name={formatName(name, index)} />
                  </Grid>
                ))
              )}
            </FieldArray>
          </Grid>
        </Grid>

        <Grid item={true} xs={12}>
          <PhoneField name="PhoneField"/>
        </Grid>

        <Grid item={true} xs={12}>
          <DateField name="date" />
        </Grid>

        <Grid item={true} xs={12}>
          <Button type="submit">Submit</Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default PlaygroundForm;
